export const SET_VIDEO_PERMISSION = 'SET_VIDEO_PERMISSION'
export const SET_AUDIO_PERMISSION = 'SET_AUDIO_PERMISSION'
export const SET_MODAL_PERMISSION = 'SET_MODAL_PERMISSION'
export const SET_MODAL_SERVICE_PERMISSION = 'SET_MODAL_SERVICE_PERMISSION'
